import React, { useRef, useState } from "react";
import "./Plans.css";
import PlansData from "./plan";
import { CheckoutModal } from "../BuyNow/BuyNow";

const CheckIcon = () => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <polyline points="2,6 5,9 10,3" strokeWidth="2" stroke="#fff" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlansSection = () => {
  const sectionRefs = useRef({});
  const [activeTab, setActiveTab] = useState(Object.keys(PlansData)[0] || "");

  const scrollToSection = (key) => {
    sectionRefs.current[key]?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const handleBuy = (plan) => {
    setModal({
      plan: { ...plan },
      category: {
        title: "Employer Hiring Plans",
        icon: "🏢"
      }
    });
  };
  const [modal, setModal] = useState(null);

  return (
    <>
      <div className="ps-page">
        {/* Heading */}
        <div className="ps-heading">
          <h1>Choose Your Plan</h1>
          <p>Flexible pricing designed to grow with your career goals</p>
        </div>

        {/* Sections */}
        {Object.keys(PlansData).map((key) => {
          const section = PlansData[key];
          if (!section) return null;
          return (
            <div
              key={key}
              className="ps-section"
              ref={(el) => (sectionRefs.current[key] = el)}
            >


              <div className="ps-grid">
                {section.plans?.map((plan, index) => (
                  <div
                    key={index}
                    className={`ps-card${plan.highlight ? " highlight" : ""}`}
                  >
                    {plan.highlight && (
                      <span className="ps-badge">Most Popular</span>
                    )}

                    <h3 className="ps-card-name">{plan.name}</h3>
                    <div className="ps-divider" />

                    <ul className="ps-features">
                      {plan.features?.map((feature, i) => (
                        <li key={i}>
                          <span className="ps-check"><CheckIcon /></span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    {/* note about top‑ups */}
                    {plan.topups && plan.topups.length > 0 && (
                      <div className="ps-topup-info">
                        Top-ups available: {plan.topups.map(t => t.label.split(' – ')[0]).join(', ')}
                      </div>
                    )}

                    {/* ── Price + Button in one row ── */}
                    <div className="ps-footer">
                      <div className="ps-pricing">
                        {plan.oldPrice && (
                          <span className="ps-old-price">₹{plan.oldPrice}</span>
                        )}
                        <span className="ps-price">
                          ₹{plan.price}
                          <span className="ps-gst">&nbsp;+ GST</span>
                        </span>
                      </div>

                      <button
                        className="ps-btn"
                        onClick={() => handleBuy(plan)}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

      </div>
      {modal && (
  <CheckoutModal
    plan={modal.plan}
    category={modal.category}
    onClose={() => setModal(null)}
  />
)}
    </>
  );
};

export default PlansSection;